// 파일 다운로드 헬퍼 — 바닐라 dcf.js triggerDownload 이식.
// 사전서명 URL 을 받자마자 다운로드를 시작해 사용자가 별도 클릭 없이 파일을 받는다.
export function triggerDownload(url: string) {
  try {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    a.setAttribute("download", "");
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch {
    window.open(url, "_blank");
  }
}

export const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/** 서버가 준 파일 내용(base64)을 원하는 파일명으로 저장 — 보관 URL 로 열면 스토리지 키가 붙은 이름으로 내려가는 것을 피한다 */
export function downloadBase64(base64: string, filename: string, mime: string) {
  const bin = atob(base64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
  const url = URL.createObjectURL(new Blob([bytes], { type: mime }));
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 4000);
  }
}
